import { Suspense, lazy } from 'react';
import { Navigate, useRoutes, useLocation } from 'react-router-dom';
// layouts
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
// components
import LoadingScreen from '../components/LoadingScreen';
import AuthGuard from '../layouts/AuthGuard/Authguard';
import PayToBorrower from '../pages/DonateToBorrower';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();

  return (
    <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: <Navigate to="/auth/login" replace />,
    },
    {
      path: 'auth',
      element: <Login />,
      children: [
        { element: <Navigate to="/auth/login" replace />, index: true },
        { path: 'login', element: <Login /> },
      ],
    },
    {
      path: '/dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to="/dashboard/dashboard" replace />, index: true },
        { path: 'dashboard', element: <PageOne /> },
        { path: 'Requesttojoin', element: <Requesttojoin /> },
        // { path: 'order', element: <Order /> },
        { path: 'Addcsp', element: <Addcsp /> },
        { path: 'CSP', element: <PageTwo /> },
        { path: 'payment', element: <Payment /> },
        { path: 'loanpaymentschedule', element: <LoanPaymentSchedule /> },
        { path: 'repayment', element: <Repayment /> },
        { path: 'loanpayment', element: <LoanPayment /> },
        { path: 'paytoborrower', element: <PayToBorrower /> },

        { path: 'loanpaymentschedule/detail', element: <LoanPaymentScheduleDetail /> },
        { path: 'loanpayment/detail', element: <LoanPaymentDetail /> },
        { path: 'repayment/detail', element: <RepaymentDetail /> },

        { path: 'addrepayment', element: <AddRepayment /> },

        { path: 'payment/:id', element: <PaymentDetail /> },
        { path: 'CSP/:id', element: <PageThree /> },
        {
          path: 'user',
          children: [
            { element: <Navigate to="/dashboard/user/four" replace />, index: true },
            { path: 'four', element: <PageFour /> },
            { path: 'five', element: <PageFive /> },
            { path: 'six', element: <PageSix /> },
          ],
        },
      ],
    },
    {
      path: '*',
      element: <LogoOnlyLayout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" replace /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}

// Dashboard
const PageOne = Loadable(lazy(() => import('../pages/PageOne')));
const PageTwo = Loadable(lazy(() => import('../pages/PageTwo')));
const Login = Loadable(lazy(() => import('../pages/Auth/Login')));
const PageThree = Loadable(lazy(() => import('../pages/PageThree')));
const Payment = Loadable(lazy(() => import('../pages/Payment')));
const LoanPaymentSchedule = Loadable(lazy(() => import('../pages/LoanPaymentSchedule')));
const Repayment = Loadable(lazy(() => import('../pages/Repayment')));
const LoanPayment = Loadable(lazy(() => import('../pages/LoanPayment')));

const LoanPaymentScheduleDetail = Loadable(lazy(() => import('../pages/LoanPaymentScheduleDetail')));
const LoanPaymentDetail = Loadable(lazy(() => import('../pages/LoanPaymentDetail')));
const RepaymentDetail = Loadable(lazy(() => import('../pages/RepaymentDetail')));

const AddRepayment = Loadable(lazy(() => import('../pages/AddRepayment')));

const PaymentDetail = Loadable(lazy(() => import('../pages/Paymentdetail')));
const PageFour = Loadable(lazy(() => import('../pages/PageFour')));
const Requesttojoin = Loadable(lazy(() => import('../pages/Requesttojoin')));
// const Order = Loadable(lazy(() => import('../pages/Order')));
const Addcsp = Loadable(lazy(() => import('../pages/Addcsp')));
const PageFive = Loadable(lazy(() => import('../pages/PageFive')));
const PageSix = Loadable(lazy(() => import('../pages/PageSix')));
const NotFound = Loadable(lazy(() => import('../pages/Page404')));
